webpackJsonp([300],{

/***/ 1593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TheHeader__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TheHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TheHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TheNavbar__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TheNavbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TheNavbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TheFooter__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TheFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_TheFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TheSidebar__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TheSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_TheSidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ImproveThis__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ImproveThis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ImproveThis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_menu__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__data_menu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        TheHeader: __WEBPACK_IMPORTED_MODULE_0__components_TheHeader___default.a,
        TheNavbar: __WEBPACK_IMPORTED_MODULE_1__components_TheNavbar___default.a,
        TheFooter: __WEBPACK_IMPORTED_MODULE_2__components_TheFooter___default.a,
        TheSidebar: __WEBPACK_IMPORTED_MODULE_3__components_TheSidebar___default.a,
        ImproveThis: __WEBPACK_IMPORTED_MODULE_4__components_ImproveThis___default.a
    },
    data: function data() {
        return {
            menu: [],
            meta: {}
        };
    },

    methods: {
        setMeta: function setMeta(meta) {
            this.meta = meta;
            this.menu = __WEBPACK_IMPORTED_MODULE_5__data_menu___default.a[this.meta.menu];
        },
        scrollTo: function scrollTo(hash) {
            location.href = hash;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$eventHub.$on('navigate', this.setMeta);
        this.setMeta(this.$router.currentRoute.meta);
        if (this.$route.hash) {
            this.$nextTick(function () {
                return _this.scrollTo(_this.$route.hash);
            });
        }
    }
});

/***/ }),

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1595),
  /* template */
  __webpack_require__(1596),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_routes__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_routes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_routes__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        breadcrumb: Array,
        title: String,
        subtitle: String
    },
    data: function data() {
        return {
            routes: __WEBPACK_IMPORTED_MODULE_0__data_routes___default.a
        };
    }
});

/***/ }),

/***/ 1596:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "docs-header"
  }, [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_vm._l((_vm.breadcrumb), function(item, index) {
    return [(_vm.routes[item]) ? _c('li', {
      key: item,
      class: {
        'is-active': index === _vm.breadcrumb.length - 1
      }
    }, [_c('router-link', {
      attrs: {
        "to": _vm.routes[item].path
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.routes[item].breadTitle || _vm.routes[item].title) + "\n                        ")])], 1) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('h1', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1597:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1598),
  /* template */
  __webpack_require__(1599),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_routes__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_routes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_routes__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        data: Array
    },
    methods: {
        normalizedData: function normalizedData(items) {
            return items.map(function (item) {
                return typeof item === 'string' ? __WEBPACK_IMPORTED_MODULE_0__data_routes___default.a[item] : item;
            });
        },
        backToTop: function backToTop() {
            window.scroll({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
});

/***/ }),

/***/ 1599:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "sidebar-menu"
  }, [_vm._l((_vm.data), function(items, i) {
    return [_c('p', {
      key: items.category,
      staticClass: "sidebar-label"
    }, [_vm._v("\n                    " + _vm._s(items.category) + "\n                ")]), _vm._v(" "), _c('ul', {
      key: i
    }, _vm._l((_vm.normalizedData(items.pages)), function(item) {
      return _c('li', {
        key: item.title
      }, [(item.title) ? _c('router-link', {
        attrs: {
          "to": item.path
        }
      }, [_c('span', {
        staticClass: "sidebar-menu-text"
      }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.isNew) ? _c('b-tag', {
        attrs: {
          "type": "is-success"
        }
      }, [_vm._v("New!")]) : _vm._e(), _vm._v(" "), (item.isUpdated) ? _c('b-tag', {
        attrs: {
          "type": "is-info"
        }
      }, [_vm._v("Updated")]) : _vm._e()], 1) : [_c('p', [_vm._v(_vm._s(item.category))]), _vm._v(" "), _c('ul', _vm._l((_vm.normalizedData(item.pages)), function(subItem) {
        return _c('li', {
          key: subItem.title
        }, [_c('router-link', {
          attrs: {
            "to": subItem.path
          }
        }, [_c('span', {
          staticClass: "sidebar-menu-text"
        }, [_vm._v(_vm._s(subItem.title))]), _vm._v(" "), (subItem.isNew) ? _c('b-tag', {
          attrs: {
            "type": "is-success"
          }
        }, [_vm._v("New!")]) : _vm._e(), _vm._v(" "), (subItem.isUpdated) ? _c('b-tag', {
          attrs: {
            "type": "is-info"
          }
        }, [_vm._v("\n                                            Updated\n                                        ")]) : _vm._e()], 1)], 1)
      }))]], 2)
    }))]
  })], 2), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btt",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.backToTop
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "arrow-expand-up",
      "size": "is-small"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Back to top")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1600:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1601),
  /* template */
  __webpack_require__(1602),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        githubPath: String
    }
});

/***/ }),

/***/ 1602:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero docs-improve-this"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": ("https://github.com/buefy/buefy/blob/dev/docs/" + _vm.githubPath),
      "target": "_blank"
    }
  }, [_vm._v("\n                    Improve this page on GitHub\n                ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "has-text-grey"
  }, [_vm._v("\n                This page is "), _c('strong', {
    staticClass: "has-text-grey-dark"
  }, [_vm._v("open source")]), _vm._v(".\n                Noticed a typo or something's unclear?\n            ")])
}]}

/***/ }),

/***/ 1603:
/***/ (function(module, exports) {

module.exports = {"documentation":[{"category":"Installation","pages":["documentation/start","documentation/customization","documentation/constructor-options"]},{"category":"Layout","pages":["documentation/layout"]},{"category":"UI components","pages":["documentation/affix","documentation/button","documentation/carousel","documentation/collapse","documentation/dialog","documentation/dropdown",{"category":"Form controls","pages":["documentation/autocomplete","documentation/checkbox","documentation/clockpicker","documentation/datepicker","documentation/datetimepicker","documentation/field","documentation/input","documentation/numberinput","documentation/radio","documentation/rate","documentation/select","documentation/slider","documentation/switch","documentation/taginput","documentation/timepicker","documentation/upload"]},"documentation/icon","documentation/loading","documentation/menu","documentation/message","documentation/modal","documentation/navbar","documentation/notification","documentation/pagination","documentation/progress","documentation/skeleton","documentation/snackbar","documentation/steps","documentation/table","documentation/tabs","documentation/tag","documentation/toast","documentation/tooltip"]}],"extensions":[{"category":"Input format","pages":["extensions/cleavejs"]},{"category":"Validation","pages":["extensions/veevalidate"]},{"category":"Drag & drop","pages":["extensions/sortablejs"]}]}

/***/ }),

/***/ 1604:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('TheNavbar'), _vm._v(" "), _c('section', {
    staticClass: "documentation"
  }, [(!_vm.meta.hideSidebar) ? _c('div', {
    staticClass: "sidebar-bg"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container is-fullhd docs-template-horizontal"
  }, [(!_vm.meta.hideSidebar) ? _c('TheSidebar', {
    attrs: {
      "data": _vm.menu
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "docs-main"
  }, [_c('div', {
    staticClass: "docs-main-container"
  }, [_c('TheHeader', _vm._b({}, 'TheHeader', _vm.meta, false)), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.meta.githubPath) ? [_c('ImproveThis', _vm._b({}, 'ImproveThis', _vm.meta, false))] : _vm._e()], 2)])], 1)]), _vm._v(" "), _c('TheFooter')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1593),
  /* template */
  __webpack_require__(1604),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 906:
/***/ (function(module, exports) {

module.exports = {"name":"buefy","version":"0.8.9","homepage":"https://buefy.org","description":"Lightweight UI components for Vue.js based on Bulma","author":"Rafael Beraldo <rafael.pimpa@gmail.com>","maintainers":["Walter Tommasi <tommsi20@gmail.com>"],"license":"MIT","main":"dist/cjs/index.js","module":"dist/esm/index.js","unpkg":"dist/buefy.min.js","typings":"types/index.d.ts","sideEffects":["*.css","*.scss"],"files":["dist","src","types/*.d.ts"],"repository":{"type":"git","url":"https://github.com/buefy/buefy.git"},"bugs":{"url":"https://github.com/buefy/buefy/issues"},"scripts":{"dev":"node build/dev-server.js","start":"node build/dev-server.js","lint":"eslint --ext .js,.vue src docs","lint:fix":"eslint --ext .js,.vue src docs --fix","lint:staged":"lint-staged","unit":"jest --runInBand","test":"npm run lint && npm run unit","test:watch":"npm run unit -- --watchAll","build:js":"rollup -c && rollup -c --environment MINIFY","build:js:watch":"rollup -c --watch","build:scss":"node-sass --output-style expanded src/scss/buefy-build.scss | node ./build/banner.js > dist/buefy.css && cleancss -o dist/buefy.min.css dist/buefy.css","build:scss:watch":"node-sass src/scss/buefy-build.scss --w","build:lib":"npm run build:js && npm run build:scss","build:lib:watch":"concurrently \"npm run build:js:watch\" \"npm run build:scss:watch \" ","build:docs":"node build/build.js","build":"npm run build:lib && npm run build:docs","cov":"./node_modules/codcov/bin/codcov"},"keywords":["bulma","vue","vuejs","vue-bulma","components"],"dependencies":{"bulma":"0.7.5"},"peerDependencies":{"vue":"^2.5.18"},"devDependencies":{"@applitools/eyes-cypress":"3.7.5","@babel/core":"7.3.4","@babel/plugin-syntax-dynamic-import":"7.2.0","@babel/preset-env":"7.3.4","@fortawesome/fontawesome-free":"5.3.1","@mdi/font":"2.7.94","@vue/test-utils":"1.0.0-beta.25","autoprefixer":"7.1.1","axios":"0.18.1","babel-core":"6.25.0","babel-eslint":"7.1.1","babel-jest":"22.1.0","babel-loader":"7.1.2","babel-plugin-transform-runtime":"6.22.0","babel-preset-env":"1.3.2","babel-preset-stage-2":"6.22.0","babel-register":"6.22.0","chalk":"1.1.3","clean-css-cli":"4.3.0","cleave.js":"1.0.1","clipboard":"1.7.1","codecov":"3.0.0","connect-history-api-fallback":"1.3.0","copy-webpack-plugin":"4.3.1","cross-env":"4.0.0","cross-spawn":"5.0.1","css-loader":"0.28.0","cypress":"3.4.1","eslint":"4.18.2","eslint-config-buefy":"0.0.3","eventsource-polyfill":"0.9.6","express":"4.14.1","extract-text-webpack-plugin":"3.0.2","file-loader":"0.11.1","font-awesome":"4.7.0","friendly-errors-webpack-plugin":"1.6.1","highlight.js":"9.12.0","html-webpack-plugin":"2.30.1","http-proxy-middleware":"0.17.3","jest":"23.5.0","jest-serializer-vue":"0.3.0","lint-staged":"6.1.1","node-sass":"^4.13.0","opn":"4.0.2","optimize-css-assets-webpack-plugin":"3.2.0","optimize-js-plugin":"0.0.4","ora":"1.2.0","pre-commit":"1.2.2","prerender-spa-plugin":"3.4.0","raw-loader":"0.5.1","rimraf":"2.6.0","rollup":"1.17.0","rollup-copy-plugin":"0.1.0","rollup-plugin-babel":"4.3.2","rollup-plugin-commonjs":"9.2.1","rollup-plugin-node-resolve":"4.0.1","rollup-plugin-replace":"2.1.0","rollup-plugin-terser":"4.0.4","rollup-plugin-vue":"5.0.0","sass-loader":"6.0.6","scrollreveal":"3.3.6","semver":"5.3.0","shelljs":"0.8.3","sinon":"7.5.0","sortablejs":"1.7.0","uglifyjs-webpack-plugin":"1.2.5","url-loader":"0.5.8","vee-validate":"2.1.0-beta.9","vue":"2.5.18","vue-analytics":"4.1.3","vue-jest":"2.5.0","vue-loader":"12.1.0","vue-progressbar":"0.7.2","vue-router":"2.3.1","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.18","webpack":"3.10.0","webpack-bundle-analyzer":"2.9.2","webpack-dev-server":"2.11.1","webpack-hot-middleware":"2.21.0","webpack-merge":"4.1.2"},"lint-staged":{"*.{vue,js}":["lint --fix","git add"]},"pre-commit":"lint:staged","engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/buefy.1d65c18.png";

/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(912),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 910:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bulma_package__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bulma_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bulma_package__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        light: Boolean
    },
    data: function data() {
        return {
            isMenuActive: false,
            version: __WEBPACK_IMPORTED_MODULE_0__package___default.a.version,
            bulmaVersion: __WEBPACK_IMPORTED_MODULE_1_bulma_package___default.a.version
        };
    },

    methods: {
        tweet: function tweet() {
            var width = 575;
            var height = 400;
            var left = (window.screen.width - width) / 2;
            var top = (window.screen.height - height) / 2;
            var url = 'https://twitter.com/share?url=' + encodeURIComponent(document.location.protocol + '//' + document.location.host) + '&text=Buefy: lightweight UI components for Vue.js based on Bulma&hashtags=buefy&via=rafaelpimpa, @walter_tommasi';
            var opts = 'status=1,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left;

            window.open(url, '', opts);
        },
        closeMenu: function closeMenu() {
            this.isMenuActive = false;
        },
        toggleHtmlClip: function toggleHtmlClip() {
            document.documentElement.classList.toggle('is-clipped-touch', this.isMenuActive);
        }
    },
    mounted: function mounted() {
        this.$eventHub.$on('navigate', this.closeMenu);
    }
});

/***/ }),

/***/ 911:
/***/ (function(module, exports) {

module.exports = {"_from":"bulma@0.7.5","_id":"bulma@0.7.5","_inBundle":false,"_integrity":"sha512-cX98TIn0I6sKba/DhW0FBjtaDpxTelU166pf7ICXpCCuplHWyu6C9LYZmL5PEsnePIeJaiorsTEzzNk3Tsm1hw==","_location":"/bulma","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"bulma@0.7.5","name":"bulma","escapedName":"bulma","rawSpec":"0.7.5","saveSpec":null,"fetchSpec":"0.7.5"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/bulma/-/bulma-0.7.5.tgz","_shasum":"35066c37f82c088b68f94450be758fc00a967208","_spec":"bulma@0.7.5","_where":"/root/Awesome-UI/buefy","author":{"name":"Jeremy Thomas","email":"bbxdesign@gmail.com","url":"https://jgthms.com"},"bugs":{"url":"https://github.com/jgthms/bulma/issues"},"bundleDependencies":false,"deprecated":false,"description":"Modern CSS framework based on Flexbox","devDependencies":{"autoprefixer":"^9.5.1","clean-css-cli":"^4.3.0","node-sass":"^4.12.0","postcss-cli":"^6.1.2","rimraf":"^2.6.3"},"files":["css","sass","bulma.sass","LICENSE","README.md"],"homepage":"https://bulma.io","keywords":["css","sass","flexbox","responsive","framework"],"license":"MIT","main":"bulma.sass","name":"bulma","repository":{"type":"git","url":"git+https://github.com/jgthms/bulma.git"},"scripts":{"build":"npm run build-clean && npm run build-sass && npm run build-autoprefix && npm run build-cleancss","build-autoprefix":"postcss --use autoprefixer --map false --output css/bulma.css css/bulma.css","build-clean":"rimraf css","build-cleancss":"cleancss -o css/bulma.min.css css/bulma.css","build-sass":"node-sass --output-style expanded --source-map true bulma.sass css/bulma.css","deploy":"npm run build","start":"npm run build-sass -- --watch"},"style":"bulma/css/bulma.min.css","unpkg":"css/bulma.css","version":"0.7.5"}

/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar docs-navbar is-spaced has-shadow",
    class: {
      'is-primary is-transparent': _vm.light
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/",
      "title": "Buefy: lightweight UI components for Vue.js based on Bulma",
      "active-class": ""
    }
  }, [(_vm.light) ? _c('img', {
    attrs: {
      "src": __webpack_require__(913),
      "alt": "Buefy"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(907),
      "alt": "Buefy"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item",
    class: {
      'has-text-dark': !_vm.light
    },
    attrs: {
      "href": "https://github.com/buefy/buefy",
      "target": "_blank",
      "title": "Github"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "github-circle"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "navbar-item",
    class: {
      'has-text-discord': !_vm.light
    },
    attrs: {
      "href": "https://discordapp.com/invite/ZkdFJMr",
      "target": "_blank",
      "title": "Discord"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "discord"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.isMenuActive
    },
    on: {
      "click": function($event) {
        _vm.isMenuActive = !_vm.isMenuActive
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.isMenuActive
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("\n                        Home\n                    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/documentation"
    }
  }, [_vm._v("\n                        Documentation\n                    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/extensions"
    }
  }, [_vm._v("\n                        Extensions\n                    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/expo"
    }
  }, [_vm._v("\n                        Expo\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item has-dropdown is-hoverable"
  }, [_c('div', {
    staticClass: "navbar-link"
  }, [_vm._v("Info")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-dropdown is-boxed"
  }, [_c('strong', {
    staticClass: "navbar-item is-version"
  }, [_c('span', {
    staticClass: "has-text-primary"
  }, [_vm._v("Buefy version")]), _vm._v(" "), _c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v(_vm._s(_vm.version))])]), _vm._v(" "), _c('strong', {
    staticClass: "navbar-item is-version"
  }, [_c('span', {
    staticClass: "has-text-bulma"
  }, [_vm._v("Bulma version")]), _vm._v(" "), _c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v(_vm._s(_vm.bulmaVersion))])]), _vm._v(" "), _c('hr', {
    staticClass: "navbar-divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "navbar-item",
    attrs: {
      "href": "https://github.com/buefy/buefy/releases",
      "target": "_blank"
    }
  }, [_vm._v("\n                                Changelogs\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item"
  }, [_c('a', {
    staticClass: "button is-outlined",
    class: _vm.light ? 'is-light' : 'is-twitter',
    on: {
      "click": _vm.tweet
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "twitter"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tweet")])], 1)])], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/buefy-light.7df103a.png";

/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(915),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 915:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('b-field', [_c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://github.com/buefy/buefy",
      "target": "_blank"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "github-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._v("GitHub")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-patreon",
    attrs: {
      "href": "https://www.patreon.com/jtommy",
      "target": "_blank"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "patreon"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Patreon")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('router-link', {
    staticClass: "navbar-item has-text-weight-semibold",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("\n                            Home\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item has-text-weight-semibold",
    attrs: {
      "to": "/documentation"
    }
  }, [_vm._v("\n                            Documentation\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item has-text-weight-semibold",
    attrs: {
      "to": "/extensions"
    }
  }, [_vm._v("\n                            Extensions\n                        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item has-text-weight-semibold",
    attrs: {
      "to": "/expo"
    }
  }, [_vm._v("\n                            Expo\n                        ")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                            Maintained by\n                            "), _c('a', {
    attrs: {
      "href": "https://twitter.com/walter_tommasi",
      "target": "_blank"
    }
  }, [_vm._v("Walter Tommasi")]), _vm._v(".\n                            Authored by\n                            "), _c('a', {
    attrs: {
      "href": "https://twitter.com/rafaelpimpa",
      "target": "_blank"
    }
  }, [_vm._v("Rafael Beraldo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("\n                                Buefy's source code is licensed under\n                                "), _c('a', {
    attrs: {
      "href": "http://opensource.org/licenses/mit-license.php",
      "target": "_blank"
    }
  }, [_vm._v("MIT")]), _vm._v(".\n                            ")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/300.505eedd80ac49c9fa6b0.js